import React, {useEffect, useRef} from "react";
import ImgTouchCanvas from "../../units/img-touch-canvas";

const AvatarEditor: React.FC<AvatarEditorProps> = (props) => {

    const {file, onChoose} = props

    const canvas = useRef(null)


    useEffect(() => {
        const itc = new ImgTouchCanvas({
            canvas: canvas.current,
            path: URL.createObjectURL(file)
        })

        return () => {
            URL.revokeObjectURL(itc.imgTexture.src)
            itc.dispose()
        }
    }, [file])

    const Confirm = () => {
        if (canvas && canvas.current) {
            // @ts-ignore
            canvas.current.toBlob((blob) => {
                onChoose(blob)
            }, 'image/jpeg', .95)
        }

    }

    const Cancel = () => {
        onChoose(null)
    }

    return <div className="avatar-editor">
        <canvas ref={canvas}/>
        <div className="btns">
            <div className="btn cancel" onClick={Cancel}>取消</div>
            <div className="btn" onClick={Confirm}>确认</div>
        </div>
    </div>
}

interface AvatarEditorProps {
    file: File,
    onChoose: (e: any) => void
}

export default AvatarEditor
